<template>
    <section id="photo_gallery" class="wrapper style2">
        <div class="inner">
            <header class="align-center">
                <p class="special">{{subTitle}}</p>
                <h2>{{header}}</h2>
            </header>

            <div class="gallery">
                <div v-for="(photo, index) in photos" :key="index">
                    <div class="image fit">
                        <a class="imglink" title="picture" v-on:click="show(index)">
                            <img :src="photo.img" :alt="photo.altText">
                        </a>
                    </div>
                </div>
            </div>
            
        </div>

        <VueEasyLightbox
            :visible="visible"
            :imgs="photoImgsOnly"
            :index="index"
            @hide="handleHide">
        </VueEasyLightbox>
    </section>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
    name: 'PhotoGallery',
    components: {
        VueEasyLightbox
    },
    props : {
        photos : Array
    },
    data() {
        return {
            header: 'VEJA NOSSO TRABALHO',
			subTitle: 'PROFISSIONALISMO E SERVIÇO DE QUALIDADE',
            visible: false,
            index: 0   // default
        }
    },
    methods : {
        show(index) {
            this.index = index;
            this.visible = true
        },
        handleHide() {
            this.visible = false
        }
    },
    computed : {
        photoImgsOnly : function() {
            return this.photos.map(function(p){
                return p.img;
            });
        }
    }
}
</script>

<style scoped>
#photo_gallery .gallery .image {
	-webkit-transition: all 0.3s;
    -ms-transition: all 0.3s;
    transition: all 0.3s;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
}
#photo_gallery .gallery .image:hover {
	padding: 0.5rem;
	background: linear-gradient(to right,#fce3ec,#ccd8ff);
}
.vel-btns-wrapper div.btn__close {
    top: 40px !important;
}
</style>

